<main class="main__content"  [@fadeIn]>
    <section class="content__list" id="mobile-view">
        <ul>
            <li *ngFor="let item of lista | filter: { key: 'permissao', value: true }" [routerLink]="item.link"  class="list__item">
                <div class="list__icon">
                    <img [src]="item?.imgTipo" alt="">
                </div>
                <div class="list__info">
                    <h2>{{item?.title}}</h2>
                    <p>{{item?.description}}</p>
                </div>
                <span *ngIf="item?.dataExpiracao && item.dataExpiracao >= today" class="badge">Novo!</span>
            </li>
        </ul>
    </section>
    
    <section class="content__cards" id="desktop-view">
        <div *ngFor="let card of lista | filter: { key: 'permissao', value: true }" class="card_maisAcessados" [@fadeIn] [routerLink]="card.link">
            <header class="card__maisAcessados__header">
                <section class="card__maisAcessados__header__imagens">
                    <section class="card__maisAcessados__header__title">
                        {{card?.title}}
                    </section>
                    <img class="card__maisAcessados__header__imagenCard" [src]="card?.imgTipo" alt="">
                </section>
            </header>
            <main class="card__maisAcessados__footer">
                <p class="card-description">{{card?.description}}</p>
            </main>
        </div>
    </section>
</main>